import React from "react";

const sizes = {
    desktop_heading_1: " text-[72px] leading-[110%] tracking-[0px]",
    desktop_heading_2: " text-[44px] leading-[48px] tracking-[0px]",
    desktop_heading_3: " text-[36px] leading-[44px] tracking-[0px]",
    desktop_heading_4: "text-[28px] leading-[32px] tracking-[0px]",
    desktop_heading_5: " text-[24px] leading-[28px] tracking-[0px]",
    desktop_heading_6: " text-[20px] leading-[24px] tracking-[0px]",
    desktop_description: "font-medium text-[35px] leading-[44px] tracking-[0px]",
    desktop_body_xl_bold: "font-extrabold text-[19px] leading-[28px] tracking-[0px]",
    desktop_body_xl: "font-medium text-[19px] leading-[28px] tracking-[0px]",
    desktop_body_l_bold: "font-extrabold text-[17px] leading-[28px] tracking-[0px]",
    desktop_body_l: "font-medium text-[17px] leading-[28px]  tracking-[0px]",
    desktop_body_m_bold: "font-extrabold text-[15px] leading-[24px] tracking-[0px]",
    desktop_body_m: "font-medium text-[15px] leading-[24px] tracking-[0px]",
    desktop_body_s_bold: "font-extrabold text-[13px] leading-[20px] tracking-[0px]",
    desktop_body_s: "font-medium text-[13px] leading-[20px] tracking-[0px]",
    desktop_body_xs_bold: "font-extrabold text-[11px] leading-[16px] tracking-[0.4px]",
    desktop_body_xs: "font-extrabold text-[11px] leading-[16px] tracking-[0.4px]",
    desktop_button_semiblod: "font-semibold text-[15px] leading-[18px] tracking-[0%]",
    textxs: "text-[13px] font-medium",
    texts: "text-[17px] font-medium lg:text-[14px]",
    textmd: "text-[36px] font-medium lg:text-[30px] md:text-[34px] sm:text-[32px]",
    textlg: "text-[66px] font-medium lg:text-[48px] md:text-[48px]",
    headingxs: "text-[15px] font-semibold",
    headings: "text-[16px] font-semibold lg:text-[13px]",
    headingmd: "text-[17px] font-extrabold lg:text-[14px]",
    headinglg: "font-extrabold lg:text-[108.55px] md:text-[46.79px]",
    desktop_heading_4s: "text-[28px] font-extrabold lg:text-[23px] md:text-[26px] sm:text-[28px]",
    desktop_numeric_xl_bold: "font-bold lg:text-[150px] text-[100px] lg:leading-[165px] leading-[110px]",
    desktop_numeric_l_bold: "font-bold text-[100px] lg:leading-[110px]",
};

export type HeadingProps = Partial<{
    className: string;
    as: any;
    size: keyof typeof sizes;
}> &
    React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLSpanElement>,
        HTMLSpanElement
    >;

const Heading: React.FC<React.PropsWithChildren<HeadingProps>> = ({
                                                                      children,
                                                                      className = "",
                                                                      size = "",
                                                                      as,
                                                                      ...restProps
                                                                  }) => {
    const Component = as || "h6";

    return (
        <Component
            className={` font-['Manrope'] ${className} ${sizes[size]}`}
            {...restProps}
        >
            {children}
        </Component>
    );
};

export {Heading};
